import Container from '../common/Container';
import Version from './Version';
import Size from './Size';

export default class Npm extends Container {
  static Version = Version;
  static Size = Size;
}